import { render, staticRenderFns } from "./fields.vue?vue&type=template&id=3ade1b75"
import script from "./fields.vue?vue&type=script&lang=js"
export * from "./fields.vue?vue&type=script&lang=js"
import style0 from "./fields.vue?vue&type=style&index=0&id=3ade1b75&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports